import { observer } from 'mobx-react-lite';
import { Button, Text, VStack } from 'components/ui';

export type ErrorReloadProps = {
  resetText?: string;
  onReset: () => void;
};

export const ErrorReload = observer(
  ({ resetText = 'Обновить страницу', onReset }: ErrorReloadProps) => {
    return (
      <VStack center spacing="xs">
        <VStack align="center" spacing="xxs">
          <Text color="gray.400">
            Что-то пошло не так. Попробуйте обновить страницу
          </Text>
          <Text color="gray.400">
            Если ошибка повторяется — напишите в техническую поддержку
          </Text>
        </VStack>

        <Button variant="ghost" mode="accent" size="s" onClick={onReset}>
          {resetText}
        </Button>
      </VStack>
    );
  }
);
